<template>
  <v-container
    fluid
    class="d-flex align-center justify-center fill-height pa-0 h-screen"
    style="background-color: #f6f4f1;"
  >
    <v-card
      elevation="18"
      width="450"
      class="pa-8 rounded-2xl text-center"
      style="background-color: #ffffff; border: 1px solid #e0dcd6;"
    >
      <!-- TÍTULO -->
      <h2
        class="text-h5 font-weight-bold mb-2"
        style="color: #152a34;"
      >
        Verificação de Código
      </h2>

      <!-- TEXTO -->
      <p class="text-body-2 mb-6" style="color: #6b7280;">
        O código de 6 dígitos foi enviado para:
        <br />
        <span class="font-weight-bold" style="color: #152a34;">
          {{ userEmail }}
        </span>
      </p>

      <v-form @submit.prevent="handleOtpValidation" ref="formRef">

        <!-- CAIXA OTP -->
        <v-sheet
          class="pa-4 mb-6"
          elevation="2"
          rounded
          style="background-color: #f3f3f1;"
        >
          <v-otp-input
            ref="otpRef"
            v-model="otpCode"
            type="password"
            variant="solo"
            length="6"
            color="#b99a52"
          />
        </v-sheet>

        <!-- BOTÃO PRINCIPAL -->
        <v-btn
          type="submit"
          block
          size="large"
          class="text-white"
          :loading="isSubmitting"
          :disabled="isSubmitting"
          style="
            background-color: #b99a52;
            font-weight: 600;
          "
          @mouseover="hover=true"
          @mouseleave="hover=false"
          :style="hover ? 'background-color: #a18446;' : ''"
        >
          Validar e Redefinir Senha
        </v-btn>
      </v-form>

      <!-- LINK REENVIAR -->
      <div class="text-center mt-4">
        <a
          @click.prevent="goToForgotPassword"
          href="#"
          class="text-body-2 text-decoration-none"
          style="color: #b99a52; font-weight: 600;"
        >
          Reenviar código
        </a>
      </div>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import api from "@/services/api";
import { useToastStore } from "@/store/toast";

const otpCode = ref("");
const userEmail = ref("");
const isSubmitting = ref(false);
const otpRef = ref(null);
const hover = ref(false);

const router = useRouter();
const route = useRoute();
const toastStore = useToastStore();

onMounted(async () => {
  const emailFromRoute = route.query.email;

  if (emailFromRoute) {
    userEmail.value = emailFromRoute;
  } else {
    toastStore.showToast({
      message: "E-mail de recuperação não encontrado. Tente novamente.",
      color: "error",
    });
    router.push({ name: "forgot-password" });
  }

  await nextTick();
  otpRef.value?.focus();
});

function validateForm() {
  return otpCode.value && otpCode.value.length === 6 && userEmail.value;
}

async function handleOtpValidation() {
  if (!validateForm()) {
    toastStore.showToast({
      message: "Por favor, informe um código de 6 dígitos.",
      color: "warning",
    });
    return;
  }

  isSubmitting.value = true;

  try {
    const response = await api.post("/validate-otp", {
      email: userEmail.value,
      otp_code: otpCode.value,
    });

    toastStore.showToast({
      message: response.message || "Código validado com sucesso!",
      color: "success",
    });

    router.push({
      name: "login",
      query: { email: userEmail.value, token: response.token },
    });
  } catch (error) {
    toastStore.showToast({
      message: error?.response?.data?.error || "Código inválido ou expirado.",
      color: "error",
    });
  } finally {
    isSubmitting.value = false;
  }
}

const goToForgotPassword = () => {
  router.push({ name: "forgot-password" });
};
</script>

<style scoped></style>
